import { convertMany } from 'convert'
import {
  GeckoManwayJSON,
  GeckoMeasurement,
  GeckoMeasurementUnit,
  generateManway,
} from 'types/index'
import { v4 as uuid4 } from 'uuid'

export function generateManways_FastField(
  manways: Array<Record<string, number | Record<string, string>>>
): Map<string, GeckoManwayJSON> {
  const manwayMap = new Map<string, GeckoManwayJSON>()
  // Return early if we don't have any manways to build
  if (!manways) {
    return manwayMap
  }

  manways.forEach((manway) => {
    const manwayData = manway.fields as Record<string, string>
    const manwayXPosition = convertMany(manwayData.x_landmark).to('ft')
    const manwayYPosition = convertMany(manwayData.y_landmark).to('ft')
    const manwayRadius = convertMany(manwayData.diameter).to('ft') / 2

    const xPosGM = GeckoMeasurement.CreateFromValue(
      manwayXPosition,
      GeckoMeasurementUnit.Feet
    )
    const yPosGM = GeckoMeasurement.CreateFromValue(
      manwayYPosition,
      GeckoMeasurementUnit.Feet
    )
    const radiusGM = GeckoMeasurement.CreateFromValue(
      manwayRadius,
      GeckoMeasurementUnit.Feet
    )

    const manwayJSON = generateManway(
      manwayData.landmark_item,
      xPosGM,
      yPosGM,
      radiusGM,
      undefined
    )

    const manwayID = uuid4().slice(0, 6)
    manwayMap.set(manwayID, manwayJSON)
  })

  return manwayMap
}
